<template>
    <div>
        <div class="content-wrapper">
            <section class="content-header">
                <h1>
                    My ABFT
                    <small>Administration générale</small>
                </h1>
                <ol class="breadcrumb">
                    <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
                    <li class="active">My ABFT</li>
                </ol>
            </section>

            <section class="content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="nav-tabs-custom nav-tabs-custom-bottom">
                            <ul class="nav nav-tabs" role="tablist">
                                <li :class="active==1 ? 'active' : '' ">
                                    <a href="#myabft_tab_1"
                                       aria-controls="#myabft_tab_1"
                                       data-toggle="tab"
                                       @click="active=1"
                                       aria-expanded="false">Listing des membres ayant accès au scan des QrCodes</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row tab-content">
                    <div role="tabpanel" :class="active==1 ? 'active' : '' " class="col-md-12 tab-pane" id="myabft_tab_1">
                        <ListingMembresMyABFT></ListingMembresMyABFT>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import ListingMembresMyABFT from './ListingMembresMyABFT'

    export default {
        data() {
            return {
                loading: false,
                active: 1
            }
        },
        computed: {
            ...mapGetters({
                getRoute: 'getRoute',
            })
        },
        components: {
            ListingMembresMyABFT
        }
    }
</script>





// WEBPACK FOOTER //
// src/components/MyABFT/MyABFT_general.vue